import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { useBreakpointValue } from 'utils/mediaQuery';

import styles from './analyticsHeader.module.scss';

type AnalyticsHeaderProps = PropsWithChildren;

export const AnalyticsHeader = ({
  children,
}: AnalyticsHeaderProps): JSX.Element => {
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  return (
    <FlexBox
      gap="200"
      alignItems="center"
      padding={isSmallScreen ? '0 0 0 500' : undefined}
      className={styles.header}
    >
      {!isSmallScreen && (
        <Text.Heading color="tertiary" as="h1">
          Analytics
        </Text.Heading>
      )}

      {children}
    </FlexBox>
  );
};
